import { getAuthInstance } from '@fusion/auth-v3'
import type { PatchUserRequest, User, UserSetting } from '@/types/user'
import { GET, PATCH, POST } from './helpers'

export const patchUpdateUser = function (userId: string, userData: PatchUserRequest) {
  const body = JSON.stringify(userData)
  const auth = getAuthInstance()
  const accountId = auth.getAccountId()
  return PATCH(
    `/accounts/${accountId}/users/${userId}`,
    body,
    {},
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST
  )
}

export const postResetPassword = async function (passwordData: {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}) {
  const body = JSON.stringify(passwordData)
  const auth = getAuthInstance()
  const accountId = auth.getAccountId()
  const userId = auth.getUserId()
  return POST(
    `/accounts/${accountId}/users/${userId}/password`,
    body,
    {},
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST
  )
}

export const getUser = function (userId: string) {
  const auth = getAuthInstance()
  const accountId = auth.getAccountId()
  return GET<User>(`/accounts/${accountId}/users/${userId}`, {}, {}, APP_ENV.VITE_APP_ACCOUNTS_HOST)
}

export const patchUserFullName = function (userSettings: PatchUserRequest) {
  const body = JSON.stringify(userSettings)
  const auth = getAuthInstance()
  const accountId = auth.getAccountId()
  const userId = auth.getUserId()
  return PATCH(
    `/accounts/${accountId}/users/${userId}`,
    body,
    {},
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST
  )
}

export const patchUserSettings = function (userSettings: Partial<UserSetting>) {
  const body = JSON.stringify(userSettings)
  const auth = getAuthInstance()
  const accountId = auth.getAccountId()
  const userId = auth.getUserId()
  return PATCH(
    `/accounts/${accountId}/users/${userId}/settings`,
    body,
    {},
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST
  )
}

export const postUserSettings = function (userSettings: UserSetting) {
  const body = JSON.stringify(userSettings)
  const auth = getAuthInstance()
  const accountId = auth.getAccountId()
  const userId = auth.getUserId()
  return POST(
    `/accounts/${accountId}/users/${userId}/settings`,
    body,
    {},
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST
  )
}

export const getUserSettings = function () {
  const auth = getAuthInstance()
  const accountId = auth.getAccountId()
  const userId = auth.getUserId()
  return GET<UserSetting>(
    `/accounts/${accountId}/users/${userId}/settings`,
    {},
    {},
    APP_ENV.VITE_APP_ACCOUNTS_HOST
  )
}
